import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokonkandarshancab() {



const cardData = {
  keyword: " Mumbai to Konkan Darshan Cab Booking  ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Konkan Darshan cab booking services, offering scenic and hassle‑free travel through the beautiful Konkan coast. Whether you are planning a weekend getaway, beach tour, sightseeing trip, or family vacation, our professional drivers, well‑maintained vehicles, and punctual pickups ensure you enjoy a memorable journey along the coastal routes. We offer flexible booking options including one‑way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and groups. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Konkan Darshan cab travel.",

topPlaces: [
  {
    title: "Alibaug Beach",
    description: "Alibaug Beach is a popular coastal destination near Mumbai known for its sandy shores, relaxed vibe, and scenic sunset views. Travelers booking a Mumbai to Konkan Darshan cab can enjoy beach walks, water sports, and boat rides. The nearby Alibaug Fort adds cultural appeal, while local cafes and seafood shacks provide refreshing snacks and meals along the coastline."
  },
  {
    title: "Murud–Janjira Fort",
    description: "Murud–Janjira Fort is a majestic sea fort located off the Konkan coast near Alibaug and is famous for its impressive architecture and island location. Konkan Darshan cab travelers from Mumbai can take a short boat ride to explore this historic fort, walk through its fortifications, and enjoy panoramic sea views. The nearby Murud Beach adds to the overall seaside experience."
  },
  {
    title: "Kashid Beach",
    description: "Kashid Beach is known for its beautiful white sands, clear waters, and tranquil atmosphere. Travelers using Mumbai to Konkan Darshan cabs can relax on the beach, enjoy swimming, and capture breathtaking coastal views. Beachfront resorts, cafes, and water sports options make it a great stop for families and couples alike."
  },
  {
    title: "Ganpatipule Beach",
    description: "Ganpatipule Beach is a serene and pristine beach destination on the Konkan coast, famous for its golden sands and turquoise waters. Cab travelers from Mumbai can enjoy leisure walks, swimming, and beach picnics. Located near the famous Ganpatipule Temple, the area combines spiritual sightseeing with coastal relaxation."
  },
  {
    title: "Ratnagiri Beaches",
    description: "Ratnagiri is dotted with multiple beautiful beaches like Bhatye Beach and Mandavi Beach. Travelers booking Konkan Darshan cabs can stop here to enjoy long walks, sunset views, and local seafood. Ratnagiri’s lush greenery and coastal breeze make it a perfect destination for nature lovers and beach enthusiasts."
  },
  {
    title: "Tarkarli Beach",
    description: "Tarkarli Beach is a pristine coastal spot near the Maharashtra–Goa border, known for its clear waters and water sports like snorkeling and scuba diving. Conkan Darshan cab travelers from Mumbai can enjoy thrilling water activities, beach relaxation, and boat tours. The marine life and scenic surroundings make it a must‑visit on the Konkan route."
  },
  {
    title: "Malvan Fort",
    description: "Malvan Fort, located near the shores of Malvan, provides a fascinating glimpse into coastal history and defense architecture. Travelers using a Konkan Darshan cab can explore the fort’s strategic bastions, walk on the seawalls, and enjoy tranquil views of the Arabian Sea. The fort is close to beaches and local markets offering Malvani cuisine."
  },
  {
    title: "Vengurla Beach",
    description: "Vengurla Beach is a calm and less crowded beach destination in the Konkan region perfect for a peaceful break. Travelers from Mumbai can enjoy long beach walks, coconut groves, and relaxing views of the sunset. The serene environment makes it ideal for couples and families seeking a quiet escape."
  },
  {
    title: "Devbagh Beach",
    description: "Devbagh Beach is a scenic coastal spot known for its white sands and water activities like banana boat rides and glass‑bottom boat tours. Konkan Darshan cab travelers can enjoy swimming, sunbathing, and exploring nearby coconut groves. The pristine coastline offers plenty of photo opportunities and calm seaside moments."
  },
  {
    title: "Sindhudurg Fort",
    description: "Sindhudurg Fort is an impressive sea fort near the Maharashtra–Goa border, known for its majestic stone walls and historical significance. Travelers booking a Mumbai to Konkan Darshan cab can take a short boat ride to visit the fort, explore its architecture, and enjoy panoramic views of the Arabian Sea. The surrounding beaches and marine environment add depth to the coastal sightseeing experience."
  }
],



services: [
{
name: "Mumbai to Konkan Darshan Cab",
description: "Mumbai to Konkan Darshan cab offers a beautiful coastal journey covering some of the most scenic destinations like Ganpatipule, Tarkarli, Ratnagiri, Malvan, and Sindhudurg. This service is perfect for families, tourists, and nature lovers looking to explore the Konkan region with comfort and flexibility. The route includes breathtaking sea views, lush green hills, and peaceful villages, making the journey as memorable as the destinations. Professional drivers experienced in coastal and ghat routes ensure safe and smooth travel throughout the trip. Travelers can choose from sedan, SUV, and tempo traveller options depending on group size. Flexible itineraries allow sightseeing, beach visits, and local food stops at your own pace. With transparent pricing and easy booking, this cab service ensures a relaxed and unforgettable Konkan travel experience."
},
{
name: "Konkan Tour Package from Mumbai",
description: "Konkan tour package from Mumbai provides a well-planned travel experience covering popular coastal destinations with comfortable transport and flexible schedules. This package is ideal for multi-day trips including beaches, temples, and sightseeing spots across the Konkan belt. Travelers can enjoy a hassle-free journey with experienced drivers handling long-distance coastal routes efficiently. The package includes customizable plans based on duration, group size, and preferred locations. Comfortable vehicles ensure smooth travel across highways and ghat sections. It is the perfect choice for a complete and enjoyable Konkan holiday."
},
{
name: "Mumbai to Konkan Taxi Package",
description: "Mumbai to Konkan taxi package offers a convenient travel solution for exploring coastal Maharashtra with fixed or customizable itineraries. This service includes comfortable vehicles, experienced drivers, and flexible travel schedules for a stress-free journey. Travelers can visit multiple destinations without worrying about transport arrangements. Door-to-door pickup and drop enhance convenience for customers. Suitable for families, couples, and groups planning leisure trips. It ensures a smooth and well-organized travel experience."
},
{
name: "Konkan Darshan Cab Booking Mumbai",
description: "Konkan Darshan cab booking Mumbai allows travelers to easily reserve their cab for coastal trips with instant confirmation and flexible travel plans. Customers can choose their preferred vehicle type and travel dates based on convenience. Transparent pricing ensures no hidden costs during the journey. Online booking options make the process quick and hassle-free. Dedicated support is available for assistance before and during travel. It is the easiest way to plan your Konkan trip."
},
{
name: "Mumbai Konkan Coastal Tour Cab",
description: "Mumbai Konkan coastal tour cab service offers a scenic travel experience covering beaches, forts, temples, and local attractions along the Konkan coast. This service is ideal for travelers who want to explore multiple destinations comfortably. Professional drivers ensure safe driving across winding coastal and ghat roads. Flexible itineraries allow travelers to enjoy sightseeing at their own pace. It is suitable for family vacations, group tours, and weekend getaways. This service ensures a memorable coastal journey."
},
{
name: "Konkan Darshan Taxi Service Mumbai",
description: "Konkan Darshan taxi service Mumbai provides reliable and comfortable transportation for exploring the Konkan region. This service is designed for long-distance travel with well-maintained vehicles and experienced drivers. Travelers can enjoy peaceful journeys with multiple sightseeing stops along the way. Flexible travel options allow customization based on preferences. Suitable for both short and extended trips. It ensures a safe and enjoyable travel experience."
},
{
name: "Mumbai to Konkan Outstation Cab",
description: "Mumbai to Konkan outstation cab service offers long-distance travel with comfort and safety for coastal trips. This service is ideal for tourists planning multi-day travel across different Konkan destinations. Vehicles are well-maintained for performance on highways and ghat roads. Flexible pickup options and travel schedules add convenience. Travelers can choose between one way and round trip packages. It ensures a hassle-free and comfortable journey."
},
{
name: "Private Cab Konkan Tour Mumbai",
description: "Private cab Konkan tour Mumbai offers a personalized travel experience with exclusive vehicle usage for families and groups. Travelers can customize routes, stops, and travel schedules based on their preferences. This ensures a relaxed and stress-free journey without time restrictions. Professional drivers provide safe and reliable service throughout the trip. Comfortable seating and premium service enhance the experience. It is ideal for a private and luxurious Konkan tour."
},
{
name: "AC Taxi Konkan Darshan Mumbai",
description: "AC taxi Konkan Darshan Mumbai ensures a comfortable journey in air-conditioned vehicles during long-distance coastal travel. This service provides a pleasant environment inside the vehicle regardless of weather conditions. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, tourists, and corporate groups. Flexible pickup options add convenience. It guarantees a relaxing travel experience."
},
{
name: "Cheap Konkan Darshan Cab Mumbai",
description: "Cheap Konkan Darshan cab Mumbai offers budget-friendly travel options for exploring coastal destinations without compromising comfort and safety. This service is ideal for cost-conscious travelers looking for reliable transportation. Economical vehicle options are available for small groups and families. Transparent pricing ensures no hidden charges. Professional drivers ensure safe travel on long routes. It is a perfect balance of affordability and comfort."
}
],

tableData: [
["Mumbai to Konkan Darshan Cab","Konkan Tour Package from Mumbai"],
["Mumbai to Konkan Taxi Package","Konkan Darshan Cab Booking Mumbai"],
["Mumbai Konkan Coastal Tour Cab","Konkan Darshan Taxi Service Mumbai"],
["Mumbai to Konkan Outstation Cab","Private Cab Konkan Tour Mumbai"],
["AC Taxi Konkan Darshan Mumbai","Cheap Konkan Darshan Cab Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Complete Konkan Darshan Tour Package",
    WhyChoosedescription: "Velocity Cabs offers well-planned Mumbai to Konkan Darshan cab booking covering popular destinations like Ganpatipule, Ratnagiri, Tarkarli, Sindhudurg, and coastal beaches for a perfect Konkan tour."
  },
  {
    WhyChooseheading: "Experienced Coastal Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Konkan coastal routes and ghat sections, ensuring safe driving, smooth navigation, and a comfortable travel experience."
  },
  {
    WhyChooseheading: "Transparent Tour Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for Mumbai to Konkan Darshan cab bookings. Customers receive full fare details including toll charges, driver allowance, and travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Travel Plans",
    WhyChoosedescription: "We offer flexible 2-day, 3-day, and multi-day Konkan Darshan packages, allowing customers to customize destinations, halts, and sightseeing plans as per their travel needs."
  },
  {
    WhyChooseheading: "Comfortable AC Vehicles for Long Travel",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and suitable for long-distance travel, ensuring a relaxing journey along scenic Konkan routes."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, luxury SUVs, and Tempo Travellers suitable for families and group tours."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, railway stations, and airports across Mumbai for a smooth start to your Konkan Darshan journey."
  },
  {
    WhyChooseheading: "Trusted Konkan Travel Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Konkan Darshan cab bookings due to reliable service, professional drivers, and comfortable travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Konkan Darshan cab service?", answer: "Yes, Velocity Cabs provides complete cab packages for Mumbai to Konkan Darshan tours." },
  { question: "Which places are covered in Konkan Darshan?", answer: "Konkan Darshan includes destinations like Ganpatipule, Ratnagiri, Tarkarli, Sindhudurg Fort, Malvan beaches, and nearby coastal attractions." },
  { question: "How many days are required for Konkan Darshan?", answer: "Typically, 2 to 4 days are required depending on travel plan and number of places covered." },
  { question: "Which vehicles are available for Konkan travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, luxury SUVs, and Tempo Travellers." },
  { question: "Can I customize the Konkan tour package?", answer: "Yes, customers can customize travel routes, destinations, and duration as per their preference." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, railway stations, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Yes, advance booking is recommended especially during peak tourist seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshmukh",
    feedback:
      "A beautiful Konkan Darshan journey from Mumbai with a very comfortable cab. The ride was smooth, the route was well-planned, and the experience felt refreshing throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "The Mumbai to Konkan Darshan cab trip was excellent. The vehicle was clean, the drive was steady, and the entire travel experience was peaceful and well-organized.",
    rating: 5
  }
];




























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const mumbaiKonkanJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Konkan Darshan Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Konkan Darshan for an unforgettable coastal tour. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Konkan Darshan Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Konkan Darshan",
        "description": "Private cab from Mumbai to Konkan Darshan for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Konkan Darshan Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Konkan Darshan with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};








  return (
    <div>
      
<Helmet>
  <title>Mumbai to Konkan Darshan Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Konkan Darshan for an unforgettable coastal tour. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiKonkanJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokonkandarshancab;